import { themeVars } from '@styles/themes.css';
import { globalStyle, style } from '@vanilla-extract/css';

export const field = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  width: '100%',
});

export const inputWrap = style({
  position: 'relative',
  width: '100%',
});

export const required = style({
  color: themeVars.color.error,
  marginLeft: '0.25rem',
});

export const phone = style({
  width: '100%',
  vars: {
    '--PhoneInput-color--focus': themeVars.color.interactive.ring,
  },
});

globalStyle(`${phone} .PhoneInputInput`, {
  height: '2.5rem',
  boxSizing: 'border-box',
  border: 'none',
  borderBottom: `1px solid ${themeVars.color.interactive.inputBorder}`,
  background: themeVars.color.interactive.inputBackground,
  padding: '0.5rem 1.5rem 0.5rem 0',
  font: 'inherit',
  outline: 'none',
});

globalStyle(`${phone} .PhoneInputInput:focus-visible`, {
  borderBottomColor: themeVars.color.interactive.ring,
});

globalStyle(`${phone} .PhoneInputCountry`, { marginRight: '1rem' });

globalStyle(`${phone} .PhoneInputCountryIcon`, {
  width: '2rem',
  height: '1.4rem',
});

globalStyle(`${phone} .PhoneInputCountryIconImg`, {
  borderRadius: '5px',
});

globalStyle(`${phone} .PhoneInputCountryIcon--border`, {
  backgroundColor: 'transparent',
  boxShadow: 'none',
  borderRadius: '5px',
});

globalStyle(`${phone} .PhoneInputCountrySelectArrow`, {
  display: 'none',
});

export const inputError = style({});

globalStyle(`${inputError} .PhoneInputInput`, {
  borderBottomColor: themeVars.color.error,
});

export const validationIcon = style({
  position: 'absolute',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
  display: 'flex',
});

export const error = style({
  color: themeVars.color.error,
});
